import { useState } from 'react';
import { useParams } from 'react-router-dom';
import image from '../../../../assets/images/image.svg';
import review from '../../../../assets/images/review.svg';
import service from '../../../../assets/images/service.svg';
import whatsapp from '../../../../assets/images/whatsapp.svg';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import {
  useModelFindAboutsSection,
  useModelTop,
} from '../../../../hooks/queries/useModels';
import calculateAge from '../../../../utils/calculateAge';
import formatPhone from '../../../../utils/formatPhone';
import messageClient from '../../../../utils/messageClient';
import * as styles from './styles';

export default function About() {
  const [show, setShow] = useState(false);
  const { id } = useParams();

  const { data: modelData, isLoading: isLoadingModelTop } = useModelTop(id);

  const { data: aboutData, isLoading: isLoadingAbouts } =
    useModelFindAboutsSection(id, 'TOP');

  const loading = isLoadingModelTop || isLoadingAbouts;

  if (loading) {
    return (
      <styles.Container>
        <Loader isLoading minimal />
      </styles.Container>
    );
  }

  const { values, dateOfBirth, city, phone, fantasyName } = modelData || {};

  return (
    <styles.Container>
      <styles.Collumn>
        <styles.InfosNav>
          <a href="#media">
            <img src={image} alt="image-icon" />
            <Text.Span $bold>Ver Midias</Text.Span>
          </a>

          <a href="#service">
            <img src={service} alt="service-icon" />
            <Text.Span $bold>Ver Serviços</Text.Span>
          </a>

          <a href="#review">
            <img src={review} alt="review-icon" />
            <Text.Span $bold>Ver Avaliações</Text.Span>
          </a>
        </styles.InfosNav>

        <styles.PrinceInfos $show={show}>
          <div>
            <Text.Span>A partir de:</Text.Span>
            <h1>
              R$
              {values?.[0]?.customRate} / {values?.[0]?.value?.name}
            </h1>
          </div>
          <button
            type="button"
            onClick={() => setShow((prevState) => !prevState)}
          >
            Ver Valores
          </button>
        </styles.PrinceInfos>

        <styles.UlValues $show={show}>
          {Array.isArray(values) &&
            values.map((value) => (
              <li key={value.id}>
                <Text.Span>
                  R$ {value?.customRate} / {value?.value?.name}
                </Text.Span>
              </li>
            ))}
        </styles.UlValues>

        <styles.PhoneInfos>
          <a
            href={messageClient(phone, fantasyName)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={whatsapp} alt="whatsapp" />

            <div className="col">
              <Text.Span>Converse Agora</Text.Span>
              <h1>{formatPhone(phone)}</h1>
            </div>
          </a>
        </styles.PhoneInfos>
      </styles.Collumn>

      <styles.Row>
        <span>
          <Text.Span $bold>Cidade: </Text.Span>
          <Text.Span>{`${city?.name} - ${city?.stateAc}`}</Text.Span>
        </span>

        <span>
          <Text.Span $bold>Idade: </Text.Span>
          <Text.Span>{calculateAge(dateOfBirth)} anos</Text.Span>
        </span>

        {aboutData?.map((about) => {
          const aboutLocation = about.name === 'Possui Local';

          if (aboutLocation) {
            return (
              <Text.Span $bold className="underline" key={about.name}>
                {about.content === 'Sim' ? 'Com Local' : 'Sem Local'}
              </Text.Span>
            );
          }

          return (
            <span key={about.name}>
              <Text.Span $bold>{about.name}: </Text.Span>
              <Text.Span>{about.content}</Text.Span>
            </span>
          );
        })}
      </styles.Row>
    </styles.Container>
  );
}
